import React from "react";
import { Link } from "react-router-dom";
import { RUTAS } from "../../constants/routes.constants";
import { useLang } from "../../translations/i18n";

const NextProjectButton = ({ nextProject }) => {
  const lang = useLang();
  return (
    <Link
      to={RUTAS.PROJECT[lang].replace(":id", nextProject?.title)}
      className="f30 d-flex align-items-center"
    >
      <span className="d-flex" style={{ marginLeft: "15px" }}>
        <svg
          width="25"
          height="30"
          viewBox="0 0 9 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polyline
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeMiterlimit="10"
            points="1,1 8,8 1,15"
          ></polyline>
        </svg>
      </span>
    </Link>
  );
};

export default NextProjectButton;
